import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SelectionMultipleItem {
  id: any;
  label: string;
  data?: any;
}

@Component({
  selector: 'app-confirmation-selection-multiple-custom',
  templateUrl: './confirmation-selection-multiple-custom.fragment.html',
  styleUrls: ['./confirmation-selection-multiple-custom.fragment.scss']
})

export class ConfirmationSelectionMultipleCustomFragment {

  @Input() header = 'Sélection';
  @Input() message = '';
  @Input() items: SelectionMultipleItem[] = [];

  @Output() validate =
    new EventEmitter<SelectionMultipleItem[]>();

  @Output() closed =
    new EventEmitter<void>();

  public selectedIds = new Set<any>();


  public isSelected(item: SelectionMultipleItem): boolean {
    return this.selectedIds.has(item.id);
  }


  public toggle(item: SelectionMultipleItem): void {

    if (this.selectedIds.has(item.id)) {
      this.selectedIds.delete(item.id);
    } else {
      this.selectedIds.add(item.id);
    }
  }


  public onCancel(): void {
    this.closed.emit();
  }


  public onValidate(): void {

    const selectedItems = this.items.filter(
      item => this.selectedIds.has(item.id)
    );

    if (!selectedItems.length) {
      return;
    }

    this.validate.emit(selectedItems);
  }
}
